import { SubscriptionPlanFeatureForm } from "./subscription-plan-feature.form.model";

interface PlanFormType {
  name: string;
  description: string;
  price: number;
  allowedNumberOfBranches: number;
  accessToAnalytics: boolean;
  givesPremiumAccess: boolean;
  trialPeriodDays: number;
  perBookingFee: number;
  contactOnly: boolean;
  subscriptionPlanFeatures: SubscriptionPlanFeatureForm[];
}

export class PlanFormModel {
  name: string;
  description: string;
  price: number;
  allowedNumberOfBranches: number;
  accessToAnalytics: boolean;
  givesPremiumAccess: boolean;
  trialPeriodDays: number;
  perBookingFee: number;
  contactOnly: boolean;
  subscriptionPlanFeatures: SubscriptionPlanFeatureForm[];

  constructor(data?: PlanFormType) {
    this.name = data?.name || "";
    this.description = data?.description || "";
    this.price = data?.price || 0;
    this.allowedNumberOfBranches = data?.allowedNumberOfBranches || 0;
    this.accessToAnalytics = data?.accessToAnalytics ?? true;
    this.givesPremiumAccess = data?.givesPremiumAccess ?? false;
    this.trialPeriodDays = data?.trialPeriodDays || 0;
    this.perBookingFee = data?.perBookingFee || 0;
    this.contactOnly = data?.contactOnly ?? false;
    this.subscriptionPlanFeatures =
      data?.subscriptionPlanFeatures.map(
        (feature) => new SubscriptionPlanFeatureForm(feature)
      ) || [];
  }
}
